import script from "./Organigrama.vue?vue&type=script&setup=true&lang=js"
export * from "./Organigrama.vue?vue&type=script&setup=true&lang=js"

import "./Organigrama.vue?vue&type=style&index=0&id=ea55aa98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea55aa98"]])

export default __exports__